import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = (data: any, amount: any) => {
  if (isStatusOK(data)) {
    return { ...data.data, amount }
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

const getBody = (amount: string) => {
  return {
    transaction: {
      method: {
        type: 0,
        subType: 0,
      },
      application: RootStore?.agent?.session?.CHANNEL_ID, //Channel ID of APP.
    },
    amount: {
      netAmount: amount,
      grossAmount: amount,
      charges: [],
    },
  }
}

export const getSplitTnxListApi = (amount: string) => {
  let config = sitConfig(RootStore.moneyTransferSession.getTokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier

  const request: Request<{}> = {
    apiPath: APIEndPoints.transferMoney,
    method: 'POST',
    config: config,
    body: getBody(amount),
  }
  sendEventApi(RootStore.moneyTransferSession.getTokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data, amount)
    })
    .then((response) => {
      sendEventApi(RootStore.moneyTransferSession.getTokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(RootStore.moneyTransferSession.getTokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
